"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = exports.AccordionContext = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
exports.AccordionContext = react_1.default.createContext({
    toggleItem: () => { },
    getIsExpanded: () => false,
    multiple: false
});
const Accordion = (props) => {
    const { children, multiple = false } = props;
    const [expandedItems, setExpandedItems] = react_1.default.useState(new Set());
    const getIsExpanded = (itemId) => expandedItems.has(itemId);
    const toggleItem = (itemId) => {
        let nextExpandedItems = new Set(expandedItems);
        if (nextExpandedItems.has(itemId)) {
            nextExpandedItems.delete(itemId);
        }
        else if (multiple) {
            nextExpandedItems.add(itemId);
        }
        else {
            nextExpandedItems = new Set([itemId]);
        }
        setExpandedItems(nextExpandedItems);
    };
    const context = {
        toggleItem: toggleItem,
        getIsExpanded: getIsExpanded,
        multiple: multiple || false
    };
    return (react_1.default.createElement(foundations_1.Box, null,
        react_1.default.createElement(exports.AccordionContext.Provider, { value: context }, children)));
};
exports.Accordion = Accordion;
//# sourceMappingURL=Accordion.js.map